// @ts-nocheck
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import type { MetaTrackEvent, MetaTrackEventResponse } from "../../models";
import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Event Tracker for META CAPI
 */
export const createEvent = (
  metaTrackEvent: MetaTrackEvent,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MetaTrackEventResponse>(
    {
      url: `/api/event/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: metaTrackEvent,
      signal,
    },
    options
  );
};

export const getCreateEventMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: MetaTrackEvent },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: MetaTrackEvent },
  TContext
> => {
  const mutationKey = ["createEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    { data: MetaTrackEvent }
  > = (props) => {
    const { data } = props ?? {};

    return createEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvent>>
>;
export type CreateEventMutationBody = MetaTrackEvent;
export type CreateEventMutationError = unknown;

export const useCreateEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: MetaTrackEvent },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: MetaTrackEvent },
  TContext
> => {
  const mutationOptions = getCreateEventMutationOptions(options);

  return useMutation(mutationOptions);
};
